import { PersonalDataProcessingLink } from '~/src/layouts/referral-all-products-layout/referral-all-products-layout.styles';

export const personalDataProcessingText = (
    <>
        Отправляя заявку, вы соглашаетесь{' '}
        <PersonalDataProcessingLink
            href="https://profile.mts.ru/documents/contracts/offers/politika-obrabotka-personalnih-dannih-v-pao-mts"
            target="_blank"
        >
            с&nbsp;условиями обработки персональных данных
        </PersonalDataProcessingLink>
    </>
);

export const headerBannerTitle = 'Заявка на\u00A0подключение';
